export enum Status {
    published = "published", 
    draft="draft",
    delete = "deleted"
  }